import { Suspense } from "react";
import PropertiesClient from "@/components/listings/properties-client";

export default function PropertiesPage() {
  return (
    <Suspense
      fallback={
        <div className="container mx-auto px-4 py-8">
          <div className="flex justify-center items-center h-96">
            Loading properties…
          </div>
        </div>
      }
    >
      <PropertiesClient />
    </Suspense>
  );
}
